/**
 * Shared methodology note constants.
 * Import from here instead of duplicating literal strings across components.
 */

export const WASTEWATER_METHOD_NOTE =
  'Wastewater emissions are calculated from attributed treatment activity where available, ' +
  'with Service Population default estimates used for unmatched jurisdictions. ' +
  'Data quality tiers are shown where applicable.';

export const WASTEWATER_NOT_YET_CALCULATED =
  'Wastewater emissions have not yet been calculated for this jurisdiction.';

/** Short tier label — used in tables, badges, and internal fact building. */
export const WASTEWATER_TIER_LABELS: Record<number, string> = {
  1: 'Tier 1 — Measured current-year facility data',
  2: 'Tier 2 — Measured facility data scaled to inventory year',
  3: 'Tier 3 — Supplemental facility data',
  4: 'Tier 4 — Attributed wastewater service',
  5: 'Tier 5 — Statewide default estimate',
};

/**
 * User-facing data-quality notes shown in UI callouts, tooltips, and reports.
 * These follow the scientific communication rules:
 *   Tier 1–2 → no note (return null)
 *   Tier 4   → communicate attributed confidence level
 *   Tier 5   → communicate lower confidence, never imply incorrect
 *   Uncalculable → explain missing information
 */
export const WASTEWATER_TIER_DISPLAY_NOTES: Record<number, string | null> = {
  1: null,
  2: null,
  3: null,
  4: 'Estimate based on attributed wastewater service.',
  5: 'Estimate based on statewide wastewater assumptions. This estimate has lower confidence.',
};

/** Used only when review_required = true and data tier is 1–3 (unexpected review). */
export const WASTEWATER_REVIEW_NOTE = 'Estimate under review.';

export const WASTEWATER_UNCALCULABLE_NOTE =
  'Insufficient information is available to estimate wastewater emissions.';
